// md_frontend/src/belediye/olcu.js
//
// TEK EŞİK KAYNAĞI (FAZ-86).
//
// KURAL: Bu dosyadaki SORGU metinleri, CSS'teki @media metinleriyle
// BİREBİR AYNI olmak zorundadır. Kopyalarken tek karakter değiştirme.
// Sapma bir kez yaşandı ve pahalıya mal oldu: iPad Pro 12.9" DİKEYDE
// 1024px genişlik raporlar; yalnız max-width'e bakan kural onu "masaüstü"
// sayıp sohbeti tamamen gizlemişti (bkz. GorevDetayPage.js:397-411).
//
// ── NEDEN YÜKSEKLİK DE SORULUYOR ───────────────────────────────
// Telefon ile tableti AYIRAN şey genişlik değil, ekranın KISA KENARI:
//
//   telefon kısa kenar:  320–430px   (iPhone SE 375, 16 Pro Max 440)
//   tablet  kısa kenar:  744–1024px  (iPad mini 744, Air 820, Pro 12.9 1024)
//
// Arada 300px'lik bir boşluk var; ayracı oraya (500/600) koyuyoruz.
// Bu yüzden:
//   • DİKEYDE kısa kenar = genişlik  → max-width ile sorulur
//   • YATAYDA kısa kenar = yükseklik → max-height ile sorulur
//
// Yalnız genişliğe bakan bir kural iki yönde de yanılır:
//   - iPad Air DİKEY (820px) "telefon" sanılır  → ray yerine alt bar çizilir
//   - iPhone 16 Pro Max YATAY (956px) "tablet" sanılır → alt bar kaybolur
//
// ── MASAÜSTÜ NEDEN "VARSAYILAN" ────────────────────────────────
// MASAUSTU_SORGU bilgilendirme içindir. CSS'te masaüstü kuralları
// HİÇBİR @media içine yazılmaz; telefon/tablet sorguları onu ezer.
// Böylece hiçbir ekran boyutu "hiçbir katmana düşmeyen" boşlukta kalmaz.
//
// Nöbetçi testler:
//   __tests__/olcu.parite.faz86.test.js  → JS metni ile theme.css metni aynı mı
//   __tests__/olcu.katman.faz86.test.js  → gerçek cihaz ölçülerinde katman doğru mu
//
// Model alınan dosya: components/mesajlasma/olcu.js — o kendi 860px eşiğiyle
// kalmaya devam ediyor; mesajlaşma penceresinin kendi kararıdır.

/* ── Ham sayılar ────────────────────────────────────────────── */
export const TELEFON_KISA_PX = 599; // kısa kenarı bundan darsa telefon
export const TELEFON_YATAY_YUKSEKLIK_PX = 500; // yatayda boyu bundan alçaksa telefon
export const TABLET_KISA_PX = 600; // kısa kenarı bundan genişse tablet
export const TABLET_PX = 1023; // yatayda bunun ÜSTÜ masaüstü
export const TABLET_DIKEY_PX = 1100; // dikeyde bunun altı hâlâ tablet (iPad Pro 1024)

/* ── Sorgular — CSS ile BİREBİR AYNI ────────────────────────── */

// Telefon: dar ekran, ya da yatay tutulan alçak ekran.
export const TELEFON_SORGU =
  "(max-width: 599px), (orientation: landscape) and (max-height: 500px)";

// Tablet: kısa kenarı geniş ama sidebar'ı kalıcı taşıyacak kadar değil.
export const TABLET_SORGU =
  "(min-width: 600px) and (max-width: 1023px) and (min-height: 501px), " +
  "(orientation: portrait) and (min-width: 600px) and (max-width: 1100px)";

// "telefon ya da tablet" — sidebar'ın kalıcı OLMADIĞI her durum.
// TELEFON ∪ TABLET birleşimidir; aralarında boşluk bırakmaz.
export const DAR_SORGU =
  "(max-width: 1023px), " +
  "(orientation: portrait) and (max-width: 1100px), " +
  "(orientation: landscape) and (max-height: 500px)";

// Bilgilendirme amaçlı — CSS'te masaüstü kuralları @media'sız yazılır.
export const MASAUSTU_SORGU = "(min-width: 1024px) and (orientation: landscape)";

/* ── JS tarafı ──────────────────────────────────────────────── */
function esles(sorgu) {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(sorgu).matches;
}

export function telefonMu() {
  return esles(TELEFON_SORGU);
}
export function tabletMi() {
  return esles(TABLET_SORGU);
}
export function darMi() {
  return esles(DAR_SORGU);
}
export function masaustuMu() {
  return !esles(DAR_SORGU);
}

/**
 * Katman adı — bileşenlerin okuyacağı tek değer.
 * Sıra önemli: telefon önce sorulur, çünkü yatay telefon genişlik olarak
 * tablet aralığına düşer ve onu yükseklik kuralı ayırır.
 * @returns {"telefon"|"tablet"|"masaustu"}
 */
export function katman() {
  if (telefonMu()) return "telefon";
  if (tabletMi()) return "tablet";
  return "masaustu";
}
